module.exports = __webpack_public_path__ + "static/media/information-light.3c619a73.svg";